module.exports = __webpack_public_path__ + "img/wzw.fee2cd54.jpg";